import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetSurveyRuleKeyOptionsRPC } from "./getSurveyRuleKeyOptionsRPC";

export class GetSurveyRuleKeyOptionsRPCClientImpl extends GetSurveyRuleKeyOptionsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetSurveyRuleKeyOptionsRPC.Request): Promise<LeoRPCResult<GetSurveyRuleKeyOptionsRPC.Response, GetSurveyRuleKeyOptionsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-rules/GetSurveyRuleKeyOptions",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetSurveyRuleKeyOptionsRPC.ResponseDTO,
      GetSurveyRuleKeyOptionsRPC.Errors.ErrorsDTO,
      GetSurveyRuleKeyOptionsRPC.Response,
      GetSurveyRuleKeyOptionsRPC.Errors.Errors
    >(
      response,
      "survey-rules/GetSurveyRuleKeyOptions",
      GetSurveyRuleKeyOptionsRPC.Response.fromDTO,
      GetSurveyRuleKeyOptionsRPC.Errors.fromDTO
    );
  }
}
